<template>
    <b-card class="card1">
        <b-container fluid class="p-4 bg-light">
              <b-row>
                <b-col>
                    <b-img 
                        thumbnail fluid 
                        :src="imageUrl" 
                        alt="Image 1"
                        >

                    </b-img>
                </b-col>
                <b-col>
                    <b-row>
                        <b-col>
                            <b-row>
                                <h5>{{number}}. {{name}}</h5>
                            </b-row>
                            <b-row>
                                <Star
                                    :rating="starRating"
                                    :fontScale=1
                                    :readOnly=true
                                /> 
                                <span> {{reviewCount}}</span>
                            </b-row>
                            <b-row>
                                <Price v-if="priceRating !== null"
                                    :rating="priceRating"
                                />
                                <pre v-if="priceRating !== null"> · </pre>
                                <div 
                                    v-for="(val,key) in categories"
                                    v-bind:key="val.id">
                                    {{val.name}}<span v-if="key != categories.length - 1">, </span>
                                </div>
                            </b-row>
                        </b-col>
                        <b-col>
                            <PhoneAndAddress 
                                :phone="phoneAndAddr.phone"
                                :addr1="phoneAndAddr.addr1"
                                :addr2="phoneAndAddr.addr2"
                                :city="phoneAndAddr.city"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        "{{secondText}}..."<a href="http://more">more</a>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
        <!-- <b-card img-src="https://placekitten.com/300/300" img-alt="Card image" img-left class="mb-3">
            <b-card-text>
                Some quick example text to build on the card and make up the bulk of the card's content.
            </b-card-text>
        </b-card> -->
    </b-card>
</template>

<style scoped>

span {
    white-space:pre;
}

.card1 {
    cursor: pointer;
}

</style>

<script>
import Star from '../../place/Star'
import Price from './Price'
import PhoneAndAddress from './PhoneAndAddress'
export default {
    components: {
        Star,
        Price,
        PhoneAndAddress
    },
    props: {
        number: { type: Number },
        name: { type: String },
        imageUrl: { type: String },
        starRating: { type: Number },
        priceRating: { type: Number },
        reviewCount: { type: Number },
        categories: { type: Array },
        secondText: { type: String },
        phoneAndAddr: { type: Object }
    },
    data() {
        return {
            
        }
    },
    computed: {
        
    },
    mounted() {
        //console.log('phoneAndAddr is: ' + this.phoneAndAddr)
    }
}
</script>